// @flow
import { connect } from 'react-redux';

import { balanceSelector } from '../../../modules/Customer/selectors';
import { WalletForfeitureCountdown } from './WalletForfeitureCountdown';
import type { StateType } from '../../../modules/reducers';
import type { StateProps } from './WalletForfeitureCountdown';

const mapStateToProps = (state: StateType): StateProps => ({
  balance: balanceSelector(state),
});

export default connect(mapStateToProps)(WalletForfeitureCountdown);
